// Shared bits for the ACA configuration tabs (Policies / Affordability / Settings).
import { queryClient, apiRequest } from "@/lib/queryClient";

export async function fetchJson<T = any>(url: string): Promise<T> {
  const res = await fetch(url, { credentials: "include" });
  if (!res.ok) {
    let msg = `Request failed (${res.status})`;
    try { const j = await res.json(); msg = j.error?.formErrors?.join?.(" ") || (typeof j.error === "string" ? j.error : j.message) || msg; } catch {}
    throw new Error(msg);
  }
  return res.json();
}

/** Recompute the year and refresh every engine-derived view. */
export async function recomputeYear(clientId: number, taxYear: number) {
  await apiRequest("POST", "/api/aca/year/recompute", { clientId, taxYear });
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ["/api/aca/year"] }),
    queryClient.invalidateQueries({ queryKey: ["/api/aca/dashboard"] }),
    queryClient.invalidateQueries({ queryKey: ["/api/aca/validation"] }),
  ]);
}

export function yearOptions(): number[] {
  const current = new Date().getFullYear();
  const out: number[] = [];
  for (let y = current; y >= current - 6; y--) out.push(y);
  return out;
}

export const SAFE_HARBOR_LABELS: Record<string, string> = {
  fpl: "Federal Poverty Line",
  rate_of_pay: "Rate of Pay",
  w2: "Form W-2",
};

export const AFFORDABILITY_LABELS: Record<string, string> = {
  affordable: "Affordable",
  not_affordable: "Not Affordable",
  pending_data: "Pending Data",
  not_applicable: "Not Applicable",
  mixed: "Mixed",
};

export const LNAP_LABELS: Record<string, string> = {
  first_partial_month: "First partial month of employment",
  waiting_period: "Initial eligibility / waiting period",
  initial_measurement_period: "Initial measurement period",
  first_ale_year: "First year as an ALE (Jan–Mar)",
};

export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const money = (v: number | null | undefined) => (v == null ? "—" : `$${Number(v).toFixed(2)}`);

export function errorMessage(e: any): string {
  const d = e?.details;
  if (d) {
    if (Array.isArray(d.problems) && d.problems.length) return d.problems.join(" ");
    if (typeof d.error === "string") return d.error;
    if (d.error?.formErrors?.length) return d.error.formErrors.join(" ");
    if (d.error?.fieldErrors) return Object.entries(d.error.fieldErrors).map(([k, v]: any) => `${k}: ${(v as string[]).join(", ")}`).join("; ");
    if (d.message) return d.message;
  }
  const msg = e?.message;
  return typeof msg === "string" && msg !== "[object Object]" ? msg : "Request failed";
}
